export default {
  car: 'Auto | Autos',
  apple: 'keine Äpfel | ein Apfel | {count} Äpfel',
  message: {
    hello: 'hallo welt',
    hello2: '{0} welt',
    hello3: '%{msg} welt'
  }
}

export const numberFormats = {
  currency: {
    style: 'currency', currency: 'EUR', currencyDisplay: 'symbol'
  },
};
